/**
 * Fixed Header with headroom.js
 * @dependencies headroom.js
 */

import Headroom from 'headroom.js'

// Header Element
const headerEl = document.querySelector('.js-fixed-header');

if (headerEl) {

  const calcHeaderHeight = () => {
    const headerElHeight = headerEl.offsetHeight;
    const topHeight = headerEl.querySelector('.navbar__top').offsetHeight - 10;

    document.documentElement.style.setProperty('--top-height', ` -${topHeight}px`);
    document.documentElement.style.setProperty('--header-height', ` ${headerElHeight}px`);
  }

  window.addEventListener('load', () => {
    // Headroom Options
    const fixedHeader = new Headroom(headerEl, {
      offset: 0,
      classes: {
        // when element is initialised
        initial: "initialized",
        // when scrolling up
        pinned: "is-pinned",
        // when scrolling down
        unpinned: "is-unpinned",
        // when above offset
        top: "is-top",
        // when below offset
        notTop: "is-not-top",
        // when at bottom of scoll area
        bottom: "is-bottom",
        // when not at bottom of scroll area
        notBottom: "is-not-bottom"
      }
    });

    fixedHeader.init();
  });

  const eventsHeightHeader = ['resize', 'orientationchange', 'load'];
  for (let index = 0; index < eventsHeightHeader.length; index++) {
    const event = eventsHeightHeader[index];
    window.addEventListener(event, calcHeaderHeight)
  }
}
